import React, { Component } from 'react';
import Header from "../../components/header/Header";
import { 
    Table, 
    Button, 
    Pagination, 
    PaginationItem, 
    PaginationLink, 
    Modal, 
    ModalHeader, 
    ModalBody, 
    ModalFooter, 
    Form, 
    FormGroup, 
    Label, 
    Input,
    Row,
    Col,
    Alert
} from 'reactstrap';
import Loading from "../../components/preloader/Loading";
import httpClient from '../../services/HttpClient';
import UserForm, { validateUserForm } from '../../components/forms/UserForm';


class ManageUsersPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      limit: 10,
      currentPage: 1,
      isModalOpen: false,
      isEditMode: false,
      isLoading: false,
      searchQuery: '',
      errorMsg: '',
      userForm: {
        id: '',
        email: '',
        firstName: '',
        lastName: '',
        company: '',
        phone: '',
        role: 'USER',
        status: 'ACTIVE',
        password: '',
        confirmPassword: ''
      },
      searchTimeout: null,
      isConfirmDeleteOpen: false,
      userToDelete: null,
      deleteErrorMsg: ''
    };
  }

  componentDidMount() {
    this.fetchUsers(1);
  }

  fetchUsers = (page) => {
    const { limit } = this.state;
    const offset = (page - 1) * limit;
    const { searchQuery } = this.state;
    this.setState({ isLoading: true });

    const queryParams = new URLSearchParams({
        offset,
        limit,
        ...(searchQuery && { search: searchQuery }) // Add `search` parameter only if it is not empty
      });

    httpClient
      .get(`/user?${queryParams.toString()}`)
      .then((response) => {
        const { data } = response;
        this.setState({
          users: data,
          currentPage: page
        });
      })
      .catch((error) => {
        console.error('Error fetching users:', error);
      }).finally(() => {
        this.setState({ isLoading: false });
      });
  };

  handleSearchChange = (e) => {
    const searchQuery = e.target.value;
    this.setState({ searchQuery });

    // Clear any existing timeout
    if (this.state.searchTimeout) {
      clearTimeout(this.state.searchTimeout);
    }

    // Set a new timeout for debouncing
    const searchTimeout = setTimeout(() => {
      this.fetchUsers(1);
    }, 1000); // 1 second delay

    this.setState({ searchTimeout });
  };

  confirmDeleteUser = (user) => {
    this.setState({ isConfirmDeleteOpen: true, userToDelete: user });
  };

  cancelDeleteUser = () => {
    this.setState({ isConfirmDeleteOpen: false, userToDelete: null, deleteErrorMsg: '' });
  };

  deleteUser = () => {
    const { userToDelete } = this.state
    this.setState({ isLoading: true });
    httpClient
      .delete('/user', { data: {id:  userToDelete.id }})
      .then(() => {
        this.setState({ isConfirmDeleteOpen: false, userToDelete: null, deleteErrorMsg: '' });
        this.fetchUsers(this.state.currentPage);
      })
      .catch((err) => {
        const errorMsg = err.response?.data?.error || 
          'There was an error processing this request.  Please try again and if the issue persists contact us.';
        this.setState({ 
            isLoading: false,
            deleteErrorMsg: errorMsg
        });

      });
  };

  toggleModal = (isEditMode = false, user = null) => {
    this.setState({
      errorMsg: '',
      isModalOpen: !this.state.isModalOpen,
      isEditMode,
      userForm: isEditMode
        ? { ...user }
        : {
            id: '',
            email: '',
            firstName: '',
            lastName: '',
            company: '',
            phone: '',
            role: 'USER',
            status: 'ACTIVE',
            password: '',
            confirmPassword: ''
          }
    });
  };

  handleFormChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      userForm: {
        ...prevState.userForm,
        [name]: value
      }
    }));
  };

  handleFormSubmit = () => {
    const { userForm, isEditMode } = this.state;

    const errors = validateUserForm(userForm, isEditMode);
    if(!!errors) {
      this.setState({ 
        errorMsg: errors
      });
    } else {
      this.setState({ isLoading: true });

      const request = isEditMode
        ? httpClient.put(`/user`, userForm)
        : httpClient.post('/user', userForm);

      request
        .then(() => {
          this.toggleModal();
          this.fetchUsers(this.state.currentPage);
        })
        .catch((err) => {
          const errorMsg = err.response?.data?.error || 
            'There was an error processing this request.  Please try again and if the issue persists contact us.';

          this.setState({ 
              isLoading: false,
              errorMsg: errorMsg
          });
        });
      }
  };

  render() {
    const { users, currentPage, limit, isModalOpen, userForm, isEditMode, isLoading, searchQuery, errorMsg, deleteErrorMsg, isConfirmDeleteOpen, userToDelete } = this.state;

    const getFormattedDate = (dataString) => {
      if(!dataString) {
        return "";
      }
      const trimmedUtcString = dataString.split(".")[0] + "Z";
      const date = new Date(trimmedUtcString);
      return date.toLocaleString();
    };

    return (
        <>
        <Loading isOpen={isLoading} />
        <Header /> 
        <div className="container mt-5">
            <h1>Manage Users</h1>
            <Row>
                <Col md="6">
                    <Input
                        type="text"
                        placeholder="Search on email or name..."
                        style={{width: 400}}
                        value={searchQuery}
                        onChange={this.handleSearchChange}
                    />
                </Col>
                <Col md="6">
                    <Button className="btn btn-success rounded-pill" style={{float: 'right'}} onClick={() => this.toggleModal(false)}>Add User</Button>
                </Col>
            </Row>
            <Table className="mt-3" bordered>
            <thead>
                <tr>
                <th>ID</th>
                <th>Email</th>
                <th>Name</th>
                <th>Company</th>
                <th>Phone</th>
                <th>Role</th>
                <th>Status</th>
                <th>Last Login</th>
                <th>Updated At</th>
                <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                {users.map((user) => (
                <tr key={user.id}>
                    <td>{user.id}</td>
                    <td>{user.email}</td>
                    <td>{user.firstName + ' ' + user.lastName}</td>
                    <td>{user.company}</td>
                    <td>{user.phone}</td>
                    <td>{user.role}</td>
                    <td>{user.status}</td>
                    <td>{user.lastLoginAt == null ? "" : getFormattedDate(user.lastLoginAt)}</td>
                    <td>{user.updatedAt == null ? getFormattedDate(user.CreatedAt) : getFormattedDate(user.updatedAt)}</td>
                    <td>
                    <Button className="rounded-pill" color="warning" size="sm" onClick={() => this.toggleModal(true, user)}>Edit</Button>{' '}
                    <Button className="rounded-pill" color="danger" size="sm" onClick={() => this.confirmDeleteUser(user)}>Delete</Button>
                    </td>
                </tr>
                ))}
            </tbody>
            </Table>
            <Pagination>
                {/* Previous Button */}
                <PaginationItem disabled={currentPage === 1}>
                    <PaginationLink
                    previous
                    onClick={() => {
                        if (currentPage > 1) this.fetchUsers(currentPage - 1);
                    }}
                    />
                </PaginationItem>
                {/* Next Button */}
                <PaginationItem disabled={users.length < limit}>
                    <PaginationLink
                    next
                    onClick={() => {
                        if (users.length === limit) this.fetchUsers(currentPage + 1);
                    }}
                    />
                </PaginationItem>
                <span style={{fontSize: 16, marginTop: 5, marginLeft: 10}}>Page { currentPage }</span>
            </Pagination>

            {/* Modal for Adding/Editing Users */}
            <Modal isOpen={isModalOpen} toggle={this.toggleModal}>
            <ModalHeader toggle={this.toggleModal}>{isEditMode ? 'Edit User' : 'Add User'}</ModalHeader>
            <ModalBody>
                <UserForm userForm={userForm} onChange={this.handleFormChange} showManagementFields={true} />
                {!!errorMsg &&
                    <Alert color="danger">{errorMsg}</Alert>
                }
            </ModalBody>
            <ModalFooter>
                <Button className="rounded-pill" color="primary" onClick={this.handleFormSubmit}>
                {isEditMode ? 'Save Changes' : 'Add User'}
                </Button>{' '}
                <Button className="rounded-pill" color="secondary" onClick={this.toggleModal}>Cancel</Button>
            </ModalFooter>
            </Modal>

            <Modal isOpen={isConfirmDeleteOpen} toggle={this.cancelDeleteUser}>
                <ModalHeader toggle={this.cancelDeleteUser}>Confirm Delete</ModalHeader>
                <ModalBody>
                    Are you sure you want to delete {!userToDelete ? "" : userToDelete.firstName + " " + 
                      userToDelete.lastName + " (" + userToDelete.email + ")"}? This action cannot be undone.
                    {!!deleteErrorMsg &&
                    <div style={{color: 'red'}}>{deleteErrorMsg}</div>
                    }
                </ModalBody>
                <ModalFooter>
                    <Button className="rounded-pill" color="danger" onClick={this.deleteUser}>Delete</Button>{' '}
                    <Button className="rounded-pill" color="secondary" onClick={this.cancelDeleteUser}>Cancel</Button>
                </ModalFooter>
            </Modal>
        </div>
      </>
    );
  }
}

export default ManageUsersPage;